import { render, staticRenderFns } from "./en-footer.vue?vue&type=template&id=518e6bdf&scoped=true&"
import script from "./en-footer.vue?vue&type=script&lang=js&"
export * from "./en-footer.vue?vue&type=script&lang=js&"
import style0 from "./en-footer.vue?vue&type=style&index=0&id=518e6bdf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e6bdf",
  null
  
)

export default component.exports